<template>
  <el-card class="box-card mb-50 box-search box-partner-contact-list">
    <div v-if="site === $siteType.site_partner">
      <button class="bt-create-contact" @click="create">
        <img src="/images/icons8-write.svg">
        <span>{{ $t('contacts.index.btn_create') }}</span>
      </button>
      <div class="group-input mt-0 mb-20"></div>
    </div>
    <span class="tilte-search" style="margin-bottom: 12px;">{{ $t('contacts.index.search_title') }}</span>
    <el-form ref="dataSearch" :model="dataSearch" @submit.prevent="search" class="form-search">
      <el-form-item prop="text"  class="input-size-454">
        <el-input :placeholder="textInputSearch" v-model="dataSearch.filters[1].data" />
      </el-form-item>
      <el-form-item prop="contact_date" class="full-width form-search-date mt-20">
        <label slot="label" class="label-field-search">{{ $t('contacts.index.contact_date') }}</label>
        <date-form
          @change-date="changeDate"
          :date="dataSearch.filters[0].data"
          :key="dataSearch.filters[0].data"
          :yearPlaceHolder="this.$t('year')"
          :listYear="listYear"
        >
        </date-form>
      </el-form-item>
      <div class="mt-25 mb-25">
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{ $t('btn_search') }}</el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </div>
    </el-form>
    <table-data
      :data="data"
      :loading="loading"
      :columns="columns"
      :showIndex="false"
      @change-page="handleChangePage"
      @sort="sort"
    >
    </table-data>
  </el-card>
  <dialog-check-has-mail
      v-if="openDialogUnresolveContact"
      :openDialogUnresolveContact="true"
    >
  </dialog-check-has-mail>
</template>

<script>
  import { getListPartnerContact } from '../../../api/contact'
  import { convertStatusLabel, convertStatusLabelPartner, convertContentContactToLink } from '../../../common'
  import { YEARS_START_FROM_2022 } from '../../../constants'

  export default {
    props: {
      site: { type: Number, required: false },
      urls: { type: Object, required: true, default: {} },
      role: { type: Number, required: true },
      me: { type: Object, required: true,  default: {} },
    },
    data() {
      return {
        openDialogUnresolveContact: false,
        listQuery: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'contact_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'p_id', 'data': '' },
          ]
        },
        data: {},
        loading: true,
        columns: [
          { prop: "p_id", label: "お問い合わせコード", sortable: "custom", class: "" },
          { prop: "contact_datetime", label: "日付", sortable: "custom", class: "" },
          { prop: "company_name", label: "差出企業名", sortable: "custom", class: "" },
          { prop: "content", label: "内容", sortable: false,  class: "text-color-primary", labelClass: "text-color-default" },
          { prop: "status", label: "ステータス", sortable: "custom", align: "right"}
        ],
        sortProp: {key: 'updated_at', dir: 'descending'},
        textInputSearch: this.$t('contacts.index.search_input_placeholder_partner'),
        listYear: YEARS_START_FROM_2022,
        dataSearch: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'contact_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'p_id', 'data': '' },
          ]
        },
      }
    },

    methods: {
      getListData() {
        const query = {...this.listQuery, ...this.sortProp};
        query.filters = JSON.stringify(this.listQuery.filters);

        getListPartnerContact(query)
          .then(response => response.json())
          .then(response => {
            response.data.records = response.data.records.map(e => {
              const urlDetail = this.site === this.$siteType.site_partner ? '/contacts' : '/contacts/partner';
              return {
                ...e,
                status: (this.site === this.$siteType.site_partner ? convertStatusLabelPartner(e.status, e.status_text) : convertStatusLabel(e.status, e.status_text)),
                content: convertContentContactToLink(e.content, `${urlDetail}/${e.id}`)
              }
            });
            this.data = response.data;
            this.loading = false;
          })
          .catch((error) => {})
          .finally(() => {});
      },

      handleChangePage(page) {
        this.loading = true;
        this.listQuery.page = page;
        this.getListData();
      },

      search() {
        this.loading = true;
        this.listQuery = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
        this.listQuery.page = 1;
        this.getListData();
      },

      sort(sortProps) {
        this.sortProp = {key: sortProps.prop, dir: sortProps.order};
        this.listQuery.page = 1;
        this.getListData();
      },

      resetForm() {
        this.$refs["dataSearch"].resetFields();
        this.dataSearch = {
          page: 1,
          text: "",
          filters: [
            { 'key': 'contact_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'p_id', 'data': '' },
          ]
        }
      },

      changeDate(data) {
        this.dataSearch.filters[0].data = data;
      },

      create() {
        window.location.href = this.urls.create;
      }
    },

    created() {
      if (this.site == this.$siteType.site_partner) {
        this.columns = [
          { prop: "p_id", label: "お問い合わせコード", sortable: "custom", class: "" },
          { prop: "contact_datetime", label: "日付", sortable: "custom", class: "" },
          { prop: "content", label: "内容", sortable: false,  class: "text-color-primary", labelClass: "text-color-default" },
          { prop: "status", label: "ステータス", sortable: "custom", align: "right"}
        ];

        this.textInputSearch = this.$t('contacts.index.search_place_holder_partner_site')
        this.openDialogUnresolveContact = (this.me.login_type == 2 && !this.me.staff.mail_address) ? true : false;
      }

      this.getListData();
    },
  }
</script>

<style lang="scss">
  .box-partner-contact-list {
    .el-form {
      width: 100%;
    }
    .group-input {
      height: 25px;
    }
    .tilte-search {
      display: block;
      line-height: normal;
    }
    .el-form-item__content {
      flex-direction: column;
      align-items: flex-start;
      .label-field-search {
        display: block;
      }
    }
    .el-table {
      .el-table__cell {
        letter-spacing: 1.3px;
        line-height: 29px;
      }
    }
  }
</style>
